import React, { Component } from "react";
import axios from "axios";
import data from "./champions.json";
import { LinkContainer } from "react-router-bootstrap";

export default class ChampionTips extends Component {
  constructor(props) {
    super(props);
    this.state = {
      champions: null,
      patch: 8.4,
      allData: [],
    };
  }
  componentDidMount() {
    axios.get('https://beta.iesdev.com/api/lolstats/patches/latest').then(response => {
      return response.data.data.patch;
    }).then(patch => {
      this.setState({ patch })
      return axios.get(`https://beta.iesdev.com/api/ddragon/${patch}.1/data/en_US/champion.json`)
    }).then(response => {
      const champions = response.data.data;
      this.setState({champions})
    });

    axios.get('https://beta.iesdev.com/api/championtips/').then((response) => {
      this.setState({ allData : response.data.data });
    })
  }
  render() {
    const { champions, allData } = this.state;
    if (!champions) return <h1>Loading</h1>
    let i = 0;
    const keys = Object.keys(champions);
    const columns = [];
    while (i + 7 < keys.length) {
      columns.push(keys.slice(i, i + 7));
      i = i + 7;
    }
    columns.push(keys.slice(i));

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        <div style={{ paddingLeft: 16 }}>
          <div style={{ fontSize: 36, fontWeight: "bold" }}>
            Champion Insights
          </div>
          <div style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.5)" }}>
            Create and edit champion insight tips for Blitz desktop app
          </div>
        </div>
        {columns.map(rows => {
          return (
            <div
              style={{
                display: "flex",
                flexDirection: "row"
              }}
            >
              {rows.map(row => {
                const champion = champions[row];

                const tip = allData.find(n => {
                  return n.champion_id.toString() === champion.key
                })

                return (
                  <LinkContainer to={`/championtips/${champion.key}`}>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        width: 120,
                        paddingTop: 16,
                        paddingBottom: 16,
                        alignItems: "center"
                      }}
                    >
                      <img
                        style={{ width: 64, height: 64, borderRadius: 4 }}
                        src={`http://ddragon.leagueoflegends.com/cdn/${this.state.patch}.1/img/champion/${row}.png`}
                      />
                      <div style={{ fontSize: 14, fontWeight: "bold" }}>
                        {champion.name}
                      </div>
                      {tip &&
                        <div style={{ fontSize: 14, fontWeight: "bold", color: 'red' }}>
                          {tip.last_updated_patch}
                        </div>
                      }
                    </div>
                  </LinkContainer>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/tips/ChampionTips.js